export default __webpack_public_path__ + "static/media/expand_fullfillment.10a0729a.svg";